

export interface ParsedMessage {
  message: string;
  componentName: string;
  data: any;
  isComplete: boolean;
}

/**
 * 解析完整的JSON字符串
 * @param jsonString 完整的JSON字符串
 * @returns 解析结果
 */
export function parseCompleteMessage(jsonString: string): ParsedMessage {
    console.log('解析完整的JSON字符串===>',jsonString);
    
  try {
    // 直接使用JSON.parse解析完整的JSON
    const parsedJson = JSON.parse(jsonString);
    
    return {
      message: parsedJson.message || '',
      componentName: parsedJson.componentName || '',
      data: parsedJson.data || {},
      isComplete: true
    };
  } catch (error) {
    console.warn('JSON解析失败:', error);
    return {
      message: '',
      componentName: '',
      data: {},
      isComplete: false
    };
  }
}

export function getMessageFromStr(str: string): ParsedMessage {
    console.log('解析完整的JSON字符串getMessageFromStr===>',str);
    
  try {
    // 直接使用JSON.parse解析完整的JSON
    const parsedJson = JSON.parse(str);
    
    return {
      message: parsedJson.message || '',
      componentName: parsedJson.componentName || '',
      data: parsedJson.data || {},
      isComplete: true
    };
  } catch (error) {
    console.warn('JSON解析失败，尝试正则匹配:', error);
    
    // 尝试正则匹配的方式去获取message
    let msg = '';
    let componentName = '';
    
    // 方法1: 匹配 "message":"内容" (包括不完整的内容)
    const messagePattern1 = /"message"\s*:\s*"([^"\\]*(?:\\.[^"\\]*)*)/;
    const messageMatch1 = str.match(messagePattern1);
    if (messageMatch1) {
      msg = messageMatch1[1].replace(/\\"/g, '"').replace(/\\\\/g, '\\');
    }
    
    // 方法2: 如果方法1没找到，尝试更宽松的匹配
    if (!msg) {
      // 匹配 ge":"内容" 这种被截断的情况，但要确保不是 componentName 的值
      const messagePattern2 = /ge"\s*:\s*"([^"\\]*(?:\\.[^"\\]*)*)"/;
      const messageMatch2 = str.match(messagePattern2);
      if (messageMatch2 && !messageMatch2[1].includes('chatCourseList') && !messageMatch2[1].includes('chatBankQuotation')) {
        msg = messageMatch2[1].replace(/\\"/g, '"').replace(/\\\\/g, '\\');
      }
    }
    
    // 方法3: 如果还没找到，尝试匹配 ssage":"内容"
    if (!msg) {
      const messagePattern3 = /ssage"\s*:\s*"([^"\\]*(?:\\.[^"\\]*)*)"/;
      const messageMatch3 = str.match(messagePattern3);
      if (messageMatch3) {
        msg = messageMatch3[1].replace(/\\"/g, '"').replace(/\\\\/g, '\\');
      }
    }
    
    // 方法4: 匹配 age":"内容"
    if (!msg) {
      const messagePattern4 = /age"\s*:\s*"([^"\\]*(?:\\.[^"\\]*)*)"/;
      const messageMatch4 = str.match(messagePattern4);
      if (messageMatch4) {
        msg = messageMatch4[1].replace(/\\"/g, '"').replace(/\\\\/g, '\\');
      }
    }
    
    // 方法5: 匹配 e":"内容"
    if (!msg) {
      const messagePattern5 = /e"\s*:\s*"([^"\\]*(?:\\.[^"\\]*)*)"/;
      const messageMatch5 = str.match(messagePattern5);
      if (messageMatch5) {
        msg = messageMatch5[1].replace(/\\"/g, '"').replace(/\\\\/g, '\\');
      }
    }
    
    // 尝试提取componentName
    const componentPattern1 = /"componentName"\s*:\s*"([^"\\]*(?:\\.[^"\\]*)*)"/;
    const componentMatch1 = str.match(componentPattern1);
    if (componentMatch1) {
      componentName = componentMatch1[1];
    } else {
      // 匹配被截断的 componentN 等情况
      const componentPattern2 = /componentN[^"]*"\s*:\s*"([^"\\]*(?:\\.[^"\\]*)*)"/;
      const componentMatch2 = str.match(componentPattern2);
      if (componentMatch2) {
        componentName = componentMatch2[1];
      }
    }
    
    console.log('正则匹配结果:', { message: msg, componentName, originalStr: str });
    
    return {
      message: msg,
      componentName: componentName,
      data: {},
      isComplete: false
    };
  }
}